import { useState, useEffect } from 'react';
import { request, asignarPersonaCentro } from '../../../../shared/services/api';
import {
  modalOverlay,
  modalBox,
  fieldLabel,
  fieldInput,
  btnCancel,
  btnPrimary,
} from './persona-detail-shared';

export function AssignToCentroModal({
  personaId,
  onClose,
  onAssigned,
}: {
  personaId: string;
  onClose: () => void;
  onAssigned: () => void;
}) {
  const [centros, setCentros] = useState<Array<{ id: string; nombre: string; codigo: string }>>([]);
  const [centroId, setCentroId] = useState('');
  const [fechaInicio, setFechaInicio] = useState(new Date().toISOString().split('T')[0]);
  const [esPrincipal, setEsPrincipal] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    request<{ data: Array<{ id: string; nombre: string; codigo: string }> }>(
      '/apps/centros?porPagina=100',
    )
      .then((r) => setCentros(r.data ?? []))
      .catch(() => {});
  }, []);

  const handleAssign = async () => {
    if (!centroId) {
      setError('Selecciona un centro');
      return;
    }
    try {
      setSaving(true);
      await asignarPersonaCentro(personaId, { centroId, fechaInicio, esPrincipal });
      onAssigned();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div onClick={onClose} style={modalOverlay}>
      <div onClick={(e) => e.stopPropagation()} style={modalBox}>
        <h2 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 700, color: '#0E243E' }}>
          Asignar a centro
        </h2>
        <div style={{ marginBottom: 12 }}>
          <label style={fieldLabel}>Centro</label>
          <select
            value={centroId}
            onChange={(e) => setCentroId(e.target.value)}
            style={{ ...fieldInput, background: '#fff' }}
          >
            <option value="">-- Seleccionar --</option>
            {centros.map((c) => (
              <option key={c.id} value={c.id}>
                {c.nombre} ({c.codigo})
              </option>
            ))}
          </select>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '12px 16px',
            marginBottom: 12,
          }}
        >
          <div>
            <label style={fieldLabel}>Fecha inicio *</label>
            <input
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              style={fieldInput}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: 13,
                cursor: 'pointer',
                marginTop: 18,
              }}
            >
              <input
                type="checkbox"
                checked={esPrincipal}
                onChange={(e) => setEsPrincipal(e.target.checked)}
              />
              Es principal
            </label>
          </div>
        </div>
        {error && (
          <div
            style={{
              padding: '8px 12px',
              borderRadius: 6,
              marginBottom: 12,
              background: '#FEF2F2',
              color: '#DC2626',
              fontSize: 13,
            }}
          >
            {error}
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button onClick={onClose} style={btnCancel}>
            Cancelar
          </button>
          <button
            onClick={handleAssign}
            disabled={saving}
            style={{ ...btnPrimary, opacity: saving ? 0.7 : 1 }}
          >
            {saving ? 'Asignando...' : 'Asignar'}
          </button>
        </div>
      </div>
    </div>
  );
}
